module.exports = "/_next/static/images/rehlati-logo-87ec595bc80a851aa04a10b82c92f293.svg";